import React, { type FC } from "react";
import { useSessionFlag } from "hooks/useSessionFlag";

import "./LabelValue.scss";

export interface LabelValueProps {
    label: string | React.ReactElement;
    value?: string | number | React.ReactElement;
    labelPosition?: 'top' | 'bottom';
    className?: string;
    emptyValue?: string;
}

export const LabelValue: FC<LabelValueProps> = ({ label, value, className = '', labelPosition = 'bottom', emptyValue = '(Empty)' }) => {
    const labelPositionFlag = useSessionFlag<'top' | 'bottom'>('label-position');
    let finalLabelPosition = labelPositionFlag || labelPosition;
    const labelId = `label-${Math.random().toString(36).substr(2, 9)}`;
    
    return (
        <div className={`label-value-root ${className}`}>
            {finalLabelPosition === 'top' && (
                <div id={labelId} className="label-top" aria-label={typeof label === 'string' ? label : undefined}>
                    {label}
                </div>
            )}
            <div className="value" aria-labelledby={labelId}>
                {value === '' ? <span className="empty-value">{emptyValue}</span> : value}
            </div>
            {finalLabelPosition === 'bottom' && (
                <div id={labelId} className="label-bottom" aria-label={typeof label === 'string' ? label : undefined}>
                    {label}
                </div>
            )}
        </div>
    );
};
